import { css, html } from "lit";
import { when } from "lit-html/directives/when.js";
import { state } from "lit/decorators.js";
import "../Button/index.js";
import "../Popover/index.js";
import "../IconButton/index.js";
import "../Option/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfActionBar = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_primary_disabled = false;
    this.dsf_secondary_disabled = false;
    this._menuOpen = false;
  }
  handlePrimaryClick() {
    this.emit("primary-click");
    this._menuOpen = false;
  }
  handleSecondaryClick() {
    this.emit("secondary-click");
    this._menuOpen = false;
  }
  handleMenuOpenChanged(event) {
    this._menuOpen = event.detail;
  }
  render() {
    return html`<div
      class="flex h-72 flex-auto items-center gap-8 border border-neutral-100 bg-neutral-0 px-24 py-8 shadow-top-s"
    >
      <slot class="dsf-text-xs flex flex-auto items-center gap-8"></slot>
      <div class="flex shrink-0 items-center gap-8 mobile:hidden">
        ${when(
      this.dsf_secondary_text,
      () => html`<dsf-button
              dsf_level="secondary"
              .disabled=${this.dsf_secondary_disabled}
              @click=${this.handleSecondaryClick}
            >
              ${this.dsf_secondary_text}
            </dsf-button>`
    )}
        ${when(
      this.dsf_primary_text,
      () => html`<dsf-button
              .disabled=${this.dsf_primary_disabled}
              @click=${this.handlePrimaryClick}
            >
              ${this.dsf_primary_text}
            </dsf-button>`
    )}
      </div>
      <div class="hidden items-center mobile:flex">
        <dsf-popover
          dsf_placement="top-end"
          class="mobile-popover"
          .dsf_open=${this._menuOpen}
          @open-changed=${this.handleMenuOpenChanged}
        >
          <dsf-button
            slot="anchor"
            dsf_icon_left="EllipsisVertical"
            dsf_level="secondary"
            dsf_square
          ></dsf-button>
          ${when(
      this.dsf_primary_text,
      () => html`<dsf-option
                class="mobile-option w-full"
                .disabled=${this.dsf_primary_disabled}
                @click=${this.handlePrimaryClick}
              >
                ${this.dsf_primary_text}
              </dsf-option>`
    )}
          ${when(
      this.dsf_secondary_text,
      () => html`<dsf-option
                class="mobile-option w-full"
                .disabled=${this.dsf_secondary_disabled}
                @click=${this.handleSecondaryClick}
              >
                ${this.dsf_secondary_text}
              </dsf-option>`
    )}
        </dsf-popover>
      </div>
    </div>`;
  }
};
DsfActionBar.styles = [
  ...BaseComponent.styles,
  css`
      :host {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        z-index: var(--dsf-z-index-layout);
      }

      .mobile-popover::part(dropdown) {
        min-width: calc(17.4 * var(--dsf-base-size));
        max-width: calc(100vw - calc(4.8 * var(--dsf-base-size)));
      }

      .mobile-option:first-of-type::part(option) {
        border-top-right-radius: calc(0.4 * var(--dsf-base-size));
        border-top-left-radius: calc(0.4 * var(--dsf-base-size));
      }

      .mobile-option:last-of-type::part(option) {
        border-bottom-right-radius: calc(0.4 * var(--dsf-base-size));
        border-bottom-left-radius: calc(0.4 * var(--dsf-base-size));
      }
    `
];
__decorateClass([
  prop({ type: String })
], DsfActionBar.prototype, "dsf_primary_text", 2);
__decorateClass([
  prop({ type: String })
], DsfActionBar.prototype, "dsf_secondary_text", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfActionBar.prototype, "dsf_primary_disabled", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfActionBar.prototype, "dsf_secondary_disabled", 2);
__decorateClass([
  state()
], DsfActionBar.prototype, "_menuOpen", 2);
DsfActionBar = __decorateClass([
  defineElement("dsf-action-bar")
], DsfActionBar);
export {
  DsfActionBar
};
